var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 5C3.81 5 3 5.7875 3 6.75V17.25C3 17.7141 3.18964 18.1592 3.52721 18.4874C3.86477 18.8156 4.32261 19 4.8 19H15.5351C15.1948 18.4117 15 17.7286 15 17C15 14.7909 16.7909 13 19 13C19.7286 13 20.4117 13.1948 21 13.5351V8.5C21 8.26794 20.9052 8.04538 20.7364 7.88128C20.5676 7.71719 20.3387 7.625 20.1 7.625H4.8V6.75H19.2V5.875C19.2 5.64294 19.1052 5.42038 18.9364 5.25628C18.7676 5.09219 18.5387 5 18.3 5H4.8Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 3,
    fill: "#23B100"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnected);
export default __webpack_public_path__ + "static/media/walletConnected.4fc456cd7b8aa7eeb9f2bc66ba7af9a3.svg";
export { ForwardRef as ReactComponent };